<template>
<div>


   <!--<Section background="white"  class="image-bg"-->
   <!--         :style="{'background-image': `url(${require('../../assets/images/content/phone.jpg')})`}"-->

   <!--&gt;-->
   <!--   <nav-bar dark></nav-bar>-->


   <!--   <div class=" main-heading heading-line" style=" width: 100%;" >-->

   <!--      <div class="center display-2">-->
   <!--         連絡先-->
   <!--         &lt;!&ndash;contact us&ndash;&gt;-->
   <!--      </div>-->
   <!--   </div>-->



   <!--</Section>-->


   <v-container>
      <section id="main_section">
         <article>

            <h1>Contact Information</h1>
            <p style="margin-bottom:10px"></p>
            <p style = "margin-bottom:5px">
               <b>Better Living Clinic Endoscopy Center, PA</b><br>
               3000  Halls Ferry Road <br>
               Vicksburg MS 39180 USA
            </p>


            <b>Phone</b> : 601-638-9800 <br>
            <b>Fax </b>  : 601-638-9808 <br>
            <b>Email</b>:namihira@earthlink.net <br>

            <p style="margin-bottom:30px"></p>

            <p style = "margin-bottom:5px">
               <b> Living The Bible Radio</b><br>
               P.O. Box 821791 <br>
               Vicksburg, MS 39182<br>
            </p>
            <b>Email:</b> miekonam@earthlink.net


         </article>

      </section>
   </v-container>


</div>
</template>

<script>

import navBar from '@/components/navBar.vue'
import Section from "@/components/Section";

export default {
name: "Radio",
   components: {navBar, Section, },
}
</script>

<style scoped>
.image-bg{
   background-size: cover;
   background-position: center;
   height: 300px;
}

   td{
      padding-left: 10px;
      padding-right: 10px;
   }


.main-heading{
   height: 200px;
   display: flex;
   align-items: center;
   justify-content: center;

}


.heading-line{
   text-align: center;
   color:#ffffff;
   /*background-color:rgba(43,43,43,0.4);*/
   width: 100%;

}

</style>
